import React from 'react';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  fullPage?: boolean;
}

export default function LoadingSpinner({ className, size = 'md', fullPage = true }: LoadingSpinnerProps) {
  const sizes: Record<string, string> = { sm: 'h-8 w-8', md: 'h-12 w-12', lg: 'h-16 w-16' };
  const sizeClass = sizes[size] || sizes.md;
  const borderColor = className || 'border-cyan-500';

  const spinner = <div className={`animate-spin rounded-full ${sizeClass} border-b-2 ${borderColor}`}></div>;

  if (!fullPage)
    return (
      <div role="status" aria-live="polite">
        {spinner}
        <span className="sr-only">Chargement...</span>
      </div>
    );

  return (
    <div className="flex items-center justify-center h-64" role="status" aria-live="polite">
      {spinner}
      <span className="sr-only">Chargement...</span>
    </div>
  );
}
